import * as React from 'react';
import { useSelector } from 'react-redux';
import { trackShowMortgageBanner } from './tracking';
import { getSoprApi } from '../../utils/soprApi';
import { selectUserId } from '../../selectors/user/user';
import { useApplicationContext } from '../ApplicationContext';

export const useTrackIntoView = () => {
  const context = useApplicationContext();
  const userId = useSelector(selectUserId);

  return React.useCallback(
    (isVisible: boolean) => {
      const { abGroup } = context.custom;
      const soprApi = getSoprApi('');

      if (!isVisible || !soprApi) {
        return;
      }

      trackShowMortgageBanner({
        abGroup,
        userId,
        soprApi: soprApi.apiUrl,
        name: 'fullscreen_percent',
      });
    },
    [userId, context],
  );
};
